import { Body, Stack } from '@qred/components-library';
import React from 'react';
import styled from 'styled-components';

interface Item {
  label: string;
  value: string;
}

interface Props {
  items: Item[];
  isMobile: boolean;
  gridTemplateColumns?: 'even' | 'auto';
}

export const LabelValueGrid = ({
  items,
  isMobile,
  gridTemplateColumns = 'even',
}: Props) => {
  return (
    <Stack spacing={'sm'}>
      {items.map((item) => (
        <Grid
          key={item.label}
          $isMobile={isMobile}
          $gridTemplateColumns={gridTemplateColumns}
        >
          <Body size="lg">{item.label}</Body>
          <Body size="lg" weight={600} align={isMobile ? 'left' : 'right'}>
            {item.value}
          </Body>
        </Grid>
      ))}
    </Stack>
  );
};

const Grid = styled('div')<{
  $isMobile: boolean;
  $gridTemplateColumns: 'even' | 'auto';
}>`
  display: grid;
  ${({ $isMobile, $gridTemplateColumns }) =>
    !$isMobile &&
    `
    grid-template-columns: ${
      $gridTemplateColumns === 'even' ? '1fr 1fr' : 'auto auto'
    };
    column-gap: 32px;
  `}
`;
